import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // We'll need to create this for Tailwind
import App from './App.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);